"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function CloseIcon() {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24" },
        React.createElement("defs", null),
        React.createElement("g", { fill: "747474", fillRule: "evenodd" },
            React.createElement("path", { id: "c", d: "M13.944 11.5L19 16.556 17.556 18 12.5 12.944 7.444 18 6 16.556l5.056-5.056L6 6.444 7.444 5l5.056 5.056L17.556 5 19 6.444 13.944 11.5z" }))));
}
exports.CloseIcon = CloseIcon;
